import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const AddSymptoms = lazy(() => import("./AddSymptoms"));

const AddSymptomsPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <AddSymptoms />
    </Suspense>
  );
};

export default AddSymptomsPageLazy;
